<template>
  <div id="header" :style="{top:jiaFlag?'90px':'0px'}">
    <div class="header">
      <div class="logo" @click="$router.push({path:'/'})">
        <img src="@/assets/logo2.png" alt="" />
        <!-- <span>EC动力</span> -->
      </div>
      <ul class="ul">
        <li
          class="nav_box"
          :style="{ width: item.childList.length > 0 ? (index==2?'105px':'63px') : 'auto' }"
          v-for="(item, index) in navList"
          :key="index"
          :ref="item.path"
          @click="pushIndex(item, $refs[item.path])"
          @mousemove="moveFn(item, index)"
          @mouseout="outFn(item, index)"
        >
          <p :class="item.childList.length > 0 ? 'draw isBorder' : 'isBorder draw'" >
            {{ item.name
            }}<img
              v-if="item.childList.length > 0"
              style="margin-left: 8px"
              class="arrowUp"
              src="../../static/top22.png"
              alt=""
            />
          </p>
          <div
            class="children"
            ref="children"
            v-show="item.childList.length > 0"
          >
            <p
              class="child_text"
              v-for="(childItem, childIndex) in item.childList"
              :key="childIndex"
              @click="goTo(index, childIndex)"
            >
              {{ childItem }}
            </p>
          </div>
        </li>
      </ul>
      <a href="https://www.bjecpower.com/admin/#/login">
      <div class="admin_system">
        <div>管理后台</div>
      </div>
      </a>
    </div>

    <div class="mo_header">
      <img class="loimg" @click="$router.push({path:'/'})" src="@/assets/mo/logo.png" alt="" />
      <div style="display: flex; ">
        <a href="https://www.bjecpower.com/admin/#/login">
        <div class="admin_system">
          <div>管理后台</div>
        </div>
        </a>
        <div class="carsImg">
          <img
            @click="openCar"
            v-if="!carsImgFlag"
            src="@/assets/mo/open.png"
            alt=""
          />
          <img @click="closeCar" v-else src="@/assets/mo/close.png" alt="" />
        </div>
      </div>

      <div
        class="cralist"
        @touchmove.prevent.stop
        @mousewheel.prevent
        v-if="craFlag"
      >
        <div class="left_list" @click="closeCar"></div>
        <div class="right_car">
          <!-- <ul>
            <li v-for="(item, index) in navList" :key="index"> {{ item.name }} </li>
          </ul> -->
          <ul>
            <li @click = homeI>首页</li>
            <li @click = homeI>公司简介</li>

            <li v-for="(item, index) in list" :key="index">
              <div class="min_box">
                <div class="h5_tab" @click="clickTab(index)">
                  <p>{{ item.name }}</p>
                  <img
                    class="h5_img"
                    :src="
                      item.type
                        ? 'https://www.bjecpower.com/camera/company/slicesBottom2.png'
                        : 'https://www.bjecpower.com/camera/company/slicesTop2.png'
                    "
                    alt=""
                  />
                </div>
                <div
                  class="h5_content"
                  v-show="initSize() || (!initSize() && !item.type)"
                >
                  <div class="h5_text" @click="pusDocu(item)">
                    {{ item.txt }}
                  </div>
                  <div class="h5_text" @click="pusDocua(item)">
                    {{ item.txta }}
                  </div>
                  <div @click="pusDocub(item)"
                    class="h5_text"
                    v-if="item.textb && item.textb !=''"
                  >
                    {{ item.textb }}
                  </div>
                </div>
              </div>
            </li>
            <li @click = homeI>合作伙伴</li>
            <li @click = homeI>资质与荣誉</li>
            <li @click = homeI>联系我们</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script >
export default {
  name: "header",
  data() {
    return {
      craFlag: false,
      carsImgFlag: false,
      jiaFlag:false,
     
      list: [
        {
          name: "产品及解决方案",
          txt: "聚能运营方案",
          txta: "智慧能源解决方案",
          textb: "AI智能场站管理方案",
          type: true,
        },
        {
          name: "文档中心",
          txt: "平台接入",
          txta: "互联互通",
          type: true,
          case: true
        },
      ],
      navList: [
        { name: "首页", childList: [],  },
        { name: "公司简介", childList: [], path:'Introduction' },
        {
          name: "产品及解决方案",
          childList: ["聚能运营方案", "智慧能源解决方案", "AI智能场站管理方案"],
        },
        { name: "文档中心", childList: ["平台接入", "互联互通"] },
        { name: "合作伙伴", childList: [], path:'cooperate' },
        { name: "资质与荣誉", childList: [], path:'Qualification' },
        { name: "联系我们", childList: [], path:'us' },
      ],
    };
  },
  created() {
    
  },
  mounted() {
    this.$bus.$on("click", () => {
      this.jiaFlag = true;
   
    });
    this.$bus.$on("clickOut",(e) => {
      this.jiaFlag = e.jiaFlag
     
    })
  },
  methods: {
    homeI(){
      this.$router.push({path:'/'})
      this.craFlag = false;
      
      this.carsImgFlag = false;
    },
    clickTab(index) {
      if (!this.initSize()) {
        this.list[index].type = !this.list[index].type;
        // document.getElementsByTagName('li')[index].style.margin = ''
      }
    },
    
    pusDocu(e) {
      console.log(e)
      this.craFlag = false;
      this.carsImgFlag = false;
       if (e.txt == "平台接入") {
        this.$router.push({ path: "/Mentmo", query: { type: "1" } });
      }
      if (e.txt == "聚能运营方案") {
        this.$router.push({ path: "/Soluc" });
      }
    },
    pusDocua(e) {
      this.craFlag = false;
      this.carsImgFlag = false;
      if (e.txt == "平台接入") {
        this.$router.push({ path: "/Mentmoa", query: { type:"2"} });
      }
      if (e.txta == "智慧能源解决方案") {
        this.$router.push({ path: "/Solua" });
      }
    },
    pusDocub(e) {
      this.craFlag = false;
      this.carsImgFlag = false;
      if (e.textb == "AI智能场站管理方案") {
        this.$router.push({ path: "/Solub"});
      }
    },
    initSize() {
      return document.body.clientWidth > 768;
    },
    moveFn(e, i) {
      if (e.childList.length > 0) {
        this.$refs.children[i].style.maxHeight = e.childList.length * 40 + "px";
      }
    },
    goTo(i, childIndex) {
      let arr = [
        [],
        [],
        ["Soluc", "Solua", "Solub"],
        ["documenta", "documenth"],
      ];
      let childArr = arr[i];
      if (childArr.length == 0) {
        return;
      }
      this.$router.push({
        path: childArr[childIndex],
      });
    },
    outFn(e, i) {
      if (e.childList.length > 0) {
        this.$refs.children[i].style.maxHeight = 0;
      }
    },
    pushIndex(e, el) {
      if(e.childList.length == 0){
        console.log()
        if(this.$route.path != '/'){
          this.$router.push({
            path:'/'
          })
        }
      }
      setTimeout(()=>{
        this.$bus.$emit('scrollGo',{ name:e.name,el })
      },10)  
      
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    openCar() {
      this.craFlag = true;
      this.carsImgFlag = true;
    },
    closeCar() {
      this.craFlag = false;
      this.carsImgFlag = false;
    },
  },
};
</script>


<style scoped >
div {
  box-sizing: border-box;
}
.mo_header {
  display: none;
}
.ul {
  margin: 0;
  width: calc(100% - 157px);
  display: flex;
  justify-content: space-between;
  padding: 0 48px;
}
li {
  list-style: none;
  cursor: pointer;
  position: relative;
}
#header {
  width: 100%;
  background: #0b0b0b;
  position: fixed;
  z-index: 10;
}
#header .header {
  display: flex;
  justify-content: space-between;
  width: 69%;
  height: 40px;
  margin: 0 auto;
  line-height: 40px;
}
.draw {
  text-align: center;
  font-size: 14px;
  color: #ffffff;
  height: 38px;
  transition: color 0.25s;
  position: relative;
}
.isBorder::before,
.isBorder::after {
  box-sizing: inherit;
  content: "";
  position: absolute;
}
.draw::before,
.draw::after {
  border-bottom: 2px solid transparent;
  width: 0;
  height: 0;
}
.draw::after {
  top: 0;
  left: 0;
}
.draw:hover::before,
.draw:hover::after {
  width: 100%;
  height: 100%;
}
.draw:hover::after {
  border-bottom-color: #0084ff;
  transition: height 0.25s ease-out, width 0.25s ease-out 0.25s;
}

.admin_system {
  width: 88px;
  box-sizing: border-box;
  padding: 5px 0;
}
.admin_system > div {
  background: #0084ff;
  width: 100%;
  height: 30px;
  line-height: 32px;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
}
.admin_system > div:hover {
  background: #016ed3;
}
.logo {
  width: 69px;
  padding-top: 5px;
  cursor: pointer;
}
.logo > img {
  width: 69px;
  height: 22px;
}
.nav_box:hover .children {
  opacity: 1;
}
.nav_box {
  z-index: 10;
}
.arrowUp {
  position: absolute;
  top: 17.5px;
  width: 10px;
  height: 5px;
  transition: 0.5s;
}
.nav_box:hover .arrowUp {
  animation: rotatePlay 0.5s linear;
  transform: rotate(-180deg);
}
@keyframes rotatePlay {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-180deg);
  }
}
.nav_box .children {
  position: absolute;
  top: 40px;
  width: calc(100% + 25px);
  left:-5px;
  height: auto;
  max-height: 0px;
  background: #ffffff;
  box-shadow: 0px 2px 20px 0px rgba(17, 27, 37, 0.17);
  border: 1px solid #E5E5E5;
  overflow: hidden;
  opacity: 0;
  transition: 0.5s;
}
.children > .child_text {
  font-size: 12px;
  color: #5a6073;
}
.children > .child_text:hover {
  color: #0084ff;
}
@media screen and (max-width: 1920px) {
  /* .children {
    position: absolute;
    top: 40px;
    width: 138px;
    margin-left: 10px;
    width: 100%;
    height: auto;
    max-height: 0;
    background: #ffffff;
    overflow: hidden;
    opacity: 0;
    transition: 0.5s;
  } */
}
@media screen and (max-width: 1440px) {
  /* .children {
    position: absolute;
    top: 40px;
    width: 126px;
    margin-left: -5px;
    width: 100%;
    height: auto;
    max-height: 0;
    background: #ffffff;
    overflow: hidden;
    opacity: 0;
    transition: 0.5s;
  } */
}
@media screen and (max-width: 768px) {
  #header > .header {
    width: 100%;
    display: none;
  }
  .mo_header {
    display: block;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .mo_header .loimg {
    width: 90px;
    height: 30px;
    margin-left: 15px;
  }
  .carsImg img {
    width: 19px;
    height: 19px;
    margin: 0px 15px 0px 24px;
    padding-top: 20px;
  }
  .admin_system {
    padding: 12px 0px;
  }
  .cralist {
    width: 100%;
    height: 100vh;
    background: #000000;
    /* opacity: 0.9; */
    position: fixed;
    top: 50px;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    display: flex;
  }
  .left_list {
    width: 33%;
    height: 100%;
    background: #000000;
    opacity: 0.4;
  }
  .right_car {
    width: 67%;
    height: 100%;
    display: flex;
    display: flex;
    background: #ffffff !important;
    /* margin-left: 33%; */
  }
  .right_car ul {
    width: 100%;
  }
  .right_car ul li {
    width: 100%;
    height: auto;
    line-height: 53px;
    text-align: start;
    border-bottom: 1px solid #e5e5e5;
    background: #ffffff;
    font-size: 15px;
    font-weight: 400;
    color: #191c27;
    padding-left: 24px;
  }

  .max_box {
    display: none;
  }
  #solution {
    padding: 0;
    background-image: none;
    height: auto;
  }
  .solution_title {
    /* height: 22px; */
    font-size: 22px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #191c27;
    text-align: center;
  }
  ul {
    margin-top: 10px;
    flex-direction: column;
    margin-bottom: 40px;
  }
  li {
    width: 100%;
    margin: 0;
    padding: 0px;
    height: auto;
    border: none;
    background: #fff;
    cursor: pointer;
  }
  li:hover {
    top: 0;
    animation: none;
  }
  .min_box {
    width: 100%;
    height: 100%;
    display: block;
  }
  .min_box > .h5_tab {
    height: 52px;
    width: 100%;
    background: #fff;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    border: none;
  }
  /* .min_box > .h5_tab:nth-child(1){
    background: red;
  } */
  .min_box > .h5_tab > img {
    width: 11px;
    height: 7px;
    margin-right: 10%;
  }
  .min_box > .h5_tab > p {
    /* margin: 0 0 0 17px; */
    width: 80%;
    font-size: 15px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #191c27;
    line-height: 52px;
  }
  .min_box > .hu_tab > p {
    width: 100%;
    height: 64px;
    line-height: 64px;
    font-size: 18px;
    border-top: 1px solid #e5e5e5;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #191c27;
  }
  .min_box > .h5_tab > .h5_img {
    display: block;
  }
  .h5_content {
    margin-left: 15px;
    min-height: 80px;
    box-sizing: border-box;
  }
  .h5_content span {
    width: 104px;
    height: 40px;
    background: #0084ff;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    display: inline-block;
    font-weight: 500;
    color: #ffffff;
  }
  .h5_text {
    /* height: 53px; */

    display: block;
    font-size: 15px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #9ea5bb;

    border-top: 1px solid #e5e5e5;
    line-height: 53px;
    /* margin-bottom: 24px; */
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue